"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UUIDGenerator = void 0;
const uuid_1 = require("uuid");
/**
 * @deprecated Don't use oo modelling anymore.
 */
class UUIDGenerator {
    static new() {
        return (0, uuid_1.v4)();
    }
}
exports.UUIDGenerator = UUIDGenerator;
//# sourceMappingURL=Comparable.js.map